import { FC } from "react";
import { scrollTo } from '../../helpers';

const Main: FC = () => {
  return <div className='container-fluid main'>
    <div className="main__background"></div>
    <div className="row main__tips">
      <div className="tip-1">
        <h1>Бесплатный</h1>
        <div className='tip-1__special'>
          <h1>светотехнический расчет</h1>
        </div>
        <h1>Любой сложности</h1>
      </div>
      <div className="tip-2">
        <h2>гарантированное вознаграждение</h2>
      </div>
    </div>
    <div className="row main__application">
      <div className="application-title col-12 col-lg-7">
        <h3>Отправьте заявку, чтобы получить проект освещения</h3>
      </div>
      <div className="col-12 col-md-6 application-buttons">
        <button className='application-send' onClick={() => scrollTo('order')}>отправить заявку</button>
        <button className='application-about' onClick={() => scrollTo('to-designers')}>подробнее</button>
      </div>
    </div>
  </div>
}

export default Main
